import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getWorkingHours, fetchWorkingHoursIfNeeded } from '../redux/modules/support';

export const useWorkingHours = () => {
  const workingHours = useSelector(getWorkingHours);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchWorkingHoursIfNeeded());
  }, []);

  return workingHours;
};
